import PropTypes from "prop-types";
const ColorPropType = PropTypes.oneOf(["blue", "darkBlue", "gold", "green", "orange", "purple", "white"]);
const SizePropType = PropTypes.oneOf(["xs", "sm", "md", "lg"]);
export {
  ColorPropType,
  SizePropType
};
